module.exports = __webpack_public_path__ + "static-v-shop/1765575532973/img/ic-beneficios.9a11f22a.png";